<template>
  <content-card>
    <template #header v-if="modalState == 'start-content'">
      <p class="title m-0 p-0" v-html="t('start_content.title')"></p>
      <p class="subtitle m-0 p-0">{{ t("start_content.subtitle") }}</p>
      <div class="d-flex flex-row metrics-container flex-wrap">
        <div
          v-for="(metric, index) in $tm('start_content.metrics')"
          :key="index"
          class="col text-center d-flex flex-column align-items-center metrics"
        >
          <img :src="require('' + metric.image)" alt="" class="metrics-image" />
          <p class="metrics-name m-0 p-0" v-html="metric.name"></p>
        </div>
      </div>
    </template>
    <template #header v-else-if="modalState == 'tnc'">
      <div class="subtitle">
        {{ t("start_content.terms_condition.title") }}
      </div>
    </template>
    <template #description v-if="modalState == 'start-content'">
      <div class="d-flex steps-container flex-column">
        <div
          class="d-flex flex-row align-items-center fwd-dark-green g-24"
          v-for="(step, index) in $tm('start_content.steps')"
          :key="index"
        >
          <div class="number border-fwd-dark-green">
            {{ index + 1 }}
          </div>
          <div
            v-html="t('start_content.steps[' + index + ']', { channels: availableChannels })"
            class="col steps"
          ></div>
        </div>
      </div>
      <div class="text-center w-100 fwd-dark-green">
        <vital-sign-button
          class="continue-button bg-fwd-orange"
          @removeProfile="removeProfile"
          @updateModalState="(state) => $emit('updateModalState', state)"
        />
      </div>
    </template>
    <template #description v-else-if="modalState == 'tnc'">
      <div class="fwd-dark-green overflow-scroll h-100 flex-shrink content" @scroll="onScroll" ref="terms_conditions">
        <p>{{ t("start_content.terms_condition.opening") }}</p>
        <ol class="text-start">
          <li v-for="content in $tm('start_content.terms_condition.content')" :key="content" v-html="content"></li>
        </ol>
        <p>{{ t("start_content.terms_condition.closing") }}</p>
        <p>{{ t("start_content.terms_condition.signing") }}</p>
      </div>
      <div class="d-flex flex-column align justify-content-center g-24 align-items-center">
        <button type="button" class="bg-fwd-orange continue-button" @click="startMeasurement" :disabled="disabled">
          {{ t("button.agree") }}
        </button>
        <button
          type="button"
          class="continue-button-clear fwd-orange"
          @click="$emit('updateModalState', 'user-profile-input')"
        >
          {{ t("button.back") }}
        </button>
      </div>
    </template>
  </content-card>
</template>

<script>
import { useI18n } from "vue-i18n";
import { inject } from "vue";
import vitalSignButton from "./vital-sign-button-js.vue";

export default {
  setup() {
    const { t, locale } = useI18n();
    const { channels } = inject("channels");

    return {
      t,
      locale,
      channels,
    };
  },
  data() {
    return {
      disabled: true,
      scrollDown: true,
    };
  },
  props: {
    modalState: String,
  },
  emits: ["updateShowTC", "startMeasurement", "removeProfile", "updateModal", "updateModalState"],
  computed: {
    availableChannels() {
      let channelText = "";
      this.channels.map((channel, index) => {
        const channelName = this.t("send_report." + channel + ".name");
        channelText += channelName;
        if (index < this.channels.length - 1) {
          channelText += "/";
        }
      });
      return channelText;
    },
  },
  methods: {
    updateShowTC(val) {
      this.$emit("updateShowTC", val);
      if (val) {
        this.startMeasurement();
      }
    },
    startMeasurement() {
      this.$emit("startMeasurement");
      this.$emit("updateModalState", "condition-check");
    },
    removeProfile() {
      this.$emit("removeProfile");
    },
    onScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      if (this.scrollDown) {
        if (Math.round(scrollTop + offsetHeight) >= scrollHeight - 50) {
          this.disabled = false;
          this.scrollDown = false;
        } else if (Math.round(scrollTop + offsetHeight) < scrollHeight) {
          this.scrollDown = true;
        }
      } else {
        if (Math.round(scrollTop + offsetHeight) < scrollHeight - 50) {
          this.scrollDown = true;
        } else {
          this.scrollDown = false;
        }
      }
    },
    onResize() {
      this.checkScrollable();
    },
    checkScrollable() {
      if (this.showTC) {
        const tncElement = this.$refs.terms_conditions;
        if (tncElement.scrollHeight > tncElement.offsetHeight) {
          this.disabled = true;
          this.scrollDown = true;
        } else {
          this.disabled = false;
          this.scrollDown = false;
        }
      }
    },
  },
  components: {
    vitalSignButton,
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.checkScrollable();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
div::-webkit-scrollbar {
  display: none;
}

.back-button {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 44px;
  text-align: center;
  letter-spacing: 0.231689px;
  padding: 0;
}
.content {
  font-size: 20px;
  font-weight: 350;
  max-height: 100%;
}
.continue-button:disabled {
  opacity: 0.7;
  background-color: #e87722;
  border: none;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.2);
}
.warning-icon {
  width: 32px;
}
.warning {
  margin-top: 24px;
  padding: 18px 48px 18px 30px;
  text-align: left;
  font-weight: 400;
  background-color: rgba(238, 239, 240, 1);
  font-size: 14px;
  gap: 15px;
}
.steps-container {
  gap: 24px;
}
.start-icon {
  width: 124px;
}
.start-icon-container {
  padding-top: 48px;
  padding-bottom: 24px;
}
.number {
  display: block;
  font-weight: 800;
  font-size: 48px;
  text-align: center;
  width: 90px;
  height: 90px;
  border: 1px solid;
  border-radius: 14px;
}

.message {
  margin-top: 30px;
  font-style: normal;
  font-family: "Montserrat", sans-serif;
  text-align: center;
  font-size: 24px;
}

.metrics {
  gap: 20px;
}

.opacity {
  opacity: 0.9;
}
.question {
  padding-top: 120px;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
}
.start-content::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.steps {
  font-size: 20px;
  font-weight: 500;
}
.vital-sign {
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0.25px;
  padding-top: 44px;
}

@media (max-width: 1023px) {
  .description {
    padding: 24px;
    padding-bottom: 48px;
  }
  .question {
    padding-top: 30px;
  }
  img {
    width: 64px;
  }
  .number {
    font-size: 21px;
    height: 35px;
    width: 35px;
  }
  .vital-sign {
    font-size: 24px;
    padding-top: 24px;
  }
}

@media (max-width: 767px) {
  .steps {
    font-size: 12px;
  }
  .number {
    font-size: 15px;
    height: 25px;
    width: 25px;
  }
  .content {
    font-size: 10px;
  }
}
</style>
